import { SET_CURRENT_PAGE } from './SkeletonPageConstants';

export default (state = { currentPage: ''}, action) => {
    switch (action.type) {
        case SET_CURRENT_PAGE:
            return { ...state, currentPage: action.payload };
        default:
            return state;
    }
};
